import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { requestApi } from "../../../actions/api";
import { GetLanguageString } from "../../helper/Components";
import { customOption, LoadingSpinner } from "../../../constants/const";
import { ApiBooks } from "./ApiBooks";
import Draggable from "react-draggable";
import ApiSyllabusBook from "../setupsyllabus/ApiSetupBook";
import Select from "react-select";
import { GetSelectedLanguage } from "../../helper/Method";
import swal from "sweetalert";
const EditBooks = ({ editValue, setEditModal, setBooks }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [booksValues, setBooksValues] = useState({
    name: "",
    staticBookType: {},
  });
  const [syllabusBooks, setSyllabusBook] = useState([]);
  const [selectedBooks, setSelectedBook] = useState([]);

  const [selectedStaticBookType, setSelectedStaticBookType] = useState({});
  const [errors, setErrors] = useState(booksValues);
  const toggle = () => setEditModal(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  useEffect(() => {
    setLoading(true);
    requestApi("books/")
      .fetchById(editValue)
      .then((res) => {
        setBooksValues(res.data);
        setSelectedStaticBookType(res.data.staticBookType);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });

    ApiBooks()
      .getStaticBookType()
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });

    ApiSyllabusBook()
      .GetBooksBySyllabus({ Id: editValue })
      .then((res) => {
        const all = res.data || [];

        // normalize to ensure consistent shape for react-select
        const normalized = all.map((o) => ({
          ...o,
          value: o.value,
          label: o.label,
          isSelected: !!o.isSelected,
        }));

        setSyllabusBook(normalized);

        // derive selectedBooks from the same array
        const initiallySelected = normalized.filter((o) => o.isSelected);
        setSelectedBook(initiallySelected);
      })
      .catch((err) => {
        console.error("Failed to load syllabus books:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [editValue]);
  const validate = () => {
    let temp = {};
    temp.name = booksValues.name ? "" : t("settings_name_error_message");
    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({
      name: "",
    });
    setBooksValues({
      ...booksValues,
      [name]: value,
    });
  };
  const handleChange = (newSelection) => {
    const updated = newSelection || [];
    setSelectedBook(updated);

    // keep isSelected flags in sync if you ever send full list back
    setSyllabusBook((prev) =>
      prev.map((opt) => ({
        ...opt,
        isSelected: updated.some((s) => s.value === opt.value),
      }))
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    booksValues.staticBookType = selectedStaticBookType;
    //const selectedBookIds = selectedBooks.map((b) => b.value);

    const payload = {
      ...booksValues,
      staticBookType: selectedStaticBookType,
      selectedBooks: selectedBooks.map((b) => b.value),
    };
    if (validate()) {
      setLoading(true);
      ApiBooks()
        .Edit(payload)
        .then((res) => {
          setLoading(false);
          setEditModal(false);
          requestApi("books/")
            .fetchAll()
            .then((res) => {
              setBooks(res.data);
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
          if (res.data.statusCode === "200") {
            swal({
              title: t("edited_setup_books"),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "success",
              buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
            });
          } else {
            swal({
              title: t("common_error_message"),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "error",
              buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  return (
    <div>
      <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
        <Modal isOpen={true} className="inmodal" autoFocus={false}>
          <ModalHeader className="modal-title" tag="h4">
            {<GetLanguageString props="settings_edit_books" />}
          </ModalHeader>
          {!loading ? (
            <Form onSubmit={handleSubmit}>
              <ModalBody>
                <FormGroup>
                  <Label>{<GetLanguageString props="common_name" />}</Label>
                  <Input
                    autoFocus
                    type="text"
                    name="name"
                    className="ur no-drag"
                    value={booksValues.name}
                    onChange={handleInputChange}
                    {...(errors.name && { invalid: true })}
                  />
                  {errors.name && (
                    <FormFeedback>
                      <h4>{errors.name}</h4>
                    </FormFeedback>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label className="col-form-label">
                    {<GetLanguageString props="select_syllabus_book" />}
                  </Label>
                  <Select
                    isMulti
                    options={syllabusBooks}
                    value={selectedBooks}
                    components={{ Option: customOption }}
                    onChange={handleChange}
                    hideSelectedOptions={true}
                    closeMenuOnSelect={false}
                    className={"ur"}
                    placeholder={
                      GetSelectedLanguage() === "en"
                        ? "Select Book"
                        : "منتخب کریں"
                    }
                    getOptionValue={(o) => o.value}
                    getOptionLabel={(o) => o.label}
                  />
                </FormGroup>
              </ModalBody>{" "}
              <ModalFooter>
                <Button color="white" onClick={toggle}>
                  {<GetLanguageString props="common_cancel" />}
                </Button>
                <Button color="primary" type="submit">
                  {<GetLanguageString props="common_save_changes" />}
                </Button>
              </ModalFooter>
            </Form>
          ) : (
            LoadingSpinner()
          )}
        </Modal>
      </Draggable>
    </div>
  );
};

export default EditBooks;
